import { render, staticRenderFns } from "./PlanejamentoAcaoFormApuracao.vue?vue&type=template&id=3af30879&"
import script from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormApuracao.vue?vue&type=script&lang=js&"
import style0 from "./PlanejamentoAcaoFormApuracao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VCard,VCheckbox,VCol,VContainer,VRow,VTextField})
